<template>

  <v-card color="grey darken-4">
    <v-toolbar card color="info">
      <v-toolbar-title><h2>{{title}}</h2></v-toolbar-title>
    </v-toolbar>
    <v-spacer></v-spacer>
      <v-container v-bind="{[`grid-list-sm`]: true}" fluid>
        <v-layout row wrap>
          <v-flex
            v-for="result in surveyResults" 
            :key="result.id"
            sm6
            xs12
          >
            <pie-chart-card 
              :data="formatData(result)"
              :options="formatOptions(result)"
              :title="result.question"
              :height="350"
            ></pie-chart-card>
          </v-flex>
        </v-layout>
      </v-container>
  </v-card>

</template>

<script>
import Vue from 'vue'
import SurveyResultsStore from '../../stores/SurveyResultsStore.js'
import PieChartCard from '../cards/PieChartCard'

export default {
  data () {
    return {
      surveyResults: SurveyResultsStore.data.results,
      datacollection: null,
      defaultColors: [
        '#008080',
        '#ff8080',
        '#4CAF50',
        '#FF5252',
        '#2196F3',
      ]
    }
  },
  components: {
    'pie-chart-card': PieChartCard
  },
  props: ['title'],
  methods: {
    formatData: function (result) {
      return {
        datasets: [{data: result.responses, backgroundColor: this.defaultColors}],
        labels: result.answers
      }
    },
    formatOptions: function (result) {
      return {
        title: {
          display: false,
          text: result.question,
          position: 'top',
          fontColor: 'white'
        },
        legend: {
          position: 'bottom',
          labels: {fontColor: 'white'}
        },
        height: 150,
        width: 150,
        responsive: true,
        maintainAspectRatio: false
      }
    },
    formatDatacollection: function () {
      var results = []
      for (let i = 0; i < this.surveyResults.length; i++) {
        const res = this.surveyResults[i]
        results.push(this.formatData(res))
      }
      return results
    },
    testData: function () {
      this.defaultData = this.formatDatacollection()
      console.log(this.defaultData)
    },
    chart: function (result) {
      return {options:this.formatOptions(result), data:this.formatData(result)}
    }
  },
  computed:{
    chartList: function () {
      var list = []
      const data = this.surveyResults
      for(let i=0; i < data.length; i++) {
        list.push({id:i, chart:this.chart(data[i])})
      }
      return list
    }
  },
  mounted () {
    this.formatDatacollection()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lists/SurveyCardList.vue